import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=60f4f938&scoped=true"
import script from "./photoList.vue?vue&type=script&lang=js"
export * from "./photoList.vue?vue&type=script&lang=js"
import style0 from "./photoList.vue?vue&type=style&index=0&id=60f4f938&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4f938",
  null
  
)

export default component.exports